module.exports = __webpack_public_path__ + "media/images/unsplash_img-p-800-a994360edf18755728319de911982ba4.jpeg";